<template>
  <span v-if="props.anchor" :id="props.anchor" class="anchor"></span>
  <div class="card" v-bind="$attrs">
    <div class="card-header d-flex justify-content-between bg-primary">
      <h4 class="text-uppercase mb-0">Groupes de quota</h4>
      <button class="btn btn-link link-dark p-0 link-underline-opacity-0 link-underline-opacity-100-hover" @click="addQuotaGroup()"><i class="fa-solid fa-plus pe-1"></i>Ajouter un groupe de quota</button>
    </div>
    <div class="card-body">
      <div v-if="quotaGroups.length === 0" class="text-muted">
        Aucun groupe de quota
      </div>
      <div v-else v-for="(quotaGroup,idx) in quotaGroups" :key="quotaGroup.key" class="card mb-3">
        <span :id="`${props.valueKey}[${idx}]`" class="anchor"></span>
        <div class="card-header d-flex justify-content-between bg-primary bg-opacity-25">
          <h4 class="text-uppercase mb-0">{{`Groupe de quota ${idx + 1}`}}</h4>
          <button class="btn btn-link link-dark p-0" @click="removeQuotaGroup(idx)"><i class="fa-regular fa-trash-can fa-lg"></i></button>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-3">
              <NumberInputComponent
                :value-key="`${props.valueKey}[${idx}].quota`"
                label="Quota"
                placeholder="Quota"
                :required="true"
                class="mb-3"
              />
            </div>
            <div class="col-12 col-md-3">
              <CheckboxComponent
                :value-key="`${props.valueKey}[${idx}].onRequest`"
                label="Selon disponibilité ?"
                :required="true"
                placeholder="Selon disponibilité ?"
                class="mb-3"
              />
            </div>
          </div>
          <AdminTravelEditHotelRoom
            class="mb-3"
            :value-key="`${props.valueKey}[${idx}].rooms`"
            v-model:validation-schema="roomsValidationSchema"
          />
        </div>

      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, watch, computed } from 'vue';
import { useFieldArray } from 'vee-validate';
import {IdNotDefined,ScrollToId } from '@/compositions/helper'
import AdminTravelEditHotelRoom from '@/views/admin/travel/AdminTravelEditHotelRoom.vue';

import * as zod from 'zod';

const validationSchema = defineModel<{ shape: zod.ZodRawShape, anchors?: Record<string, string | undefined> }>('validation-schema',{ required: false, default: () => ({ shape: {} }) });
const roomsValidationSchema = ref<{ shape: zod.ZodRawShape, anchors?: Record<string, string | undefined> }>({ shape: {} });

const props = defineProps<{
  anchor?: string
  valueKey: AllTypeKeys;
}>();

const { remove: removeQuotaGroup, push: pushQuotaGroup, fields: quotaGroups } = useFieldArray<TravelDbHotelQuotaGroup>(() => props.valueKey);

const addQuotaGroup = () => {
  pushQuotaGroup(<TravelDbHotelQuotaGroup>{
    id: IdNotDefined,
    quota: 0,
    onRequest: false,
    rooms: []
  });
  ScrollToId(`${props.valueKey}[${(quotaGroups?.value.length ?? 1) - 1}]`);
}

const mergedSchema = computed(() => {
  return {
    shape: {
      quotaGroups: zod.array(zod.object({
        id: zod.number().nonnegative(),
        quota: zod.number({message: "Le quota est obligatoire"}).min(0, 'Le quota doit être au minimum 0'),
        onRequest: zod.boolean({ message: 'Le choix selon disponibilité ou non est obligatoire' }),
        ...zod.object(roomsValidationSchema.value.shape).shape,
      })).optional()
    },
    anchors: {
      [`${props.valueKey}[\\d].id`]: "self",
      [`${props.valueKey}[\\d].quota`]: "self",
      [`${props.valueKey}[\\d].rooms`]: "self",
      ...roomsValidationSchema.value.anchors
    }
  }
});

onMounted(() => {
  validationSchema.value = mergedSchema.value
});

watch(roomsValidationSchema, async () => {
  validationSchema.value = mergedSchema.value
});
</script>
